import React, { useState, useEffect } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import { PROMOTYPES } from '../../constants/dataConfig';
import * as actions from '../../actions/index';
import Input from '../Input';
import Modal from '../Modal';
import 'react-notifications-component/dist/theme.css';
import { checkAccess } from '../../utils/admins';
import { styles } from './PromoModal.styles';
import {
  handleCheckBox,
  handleAddPromo,
  handleClose,
  onChangeData,
  handleChangeCanal,
  handleChangeOrderTypes,
  getCanals,
  handleChange,
  onSelectDate,
  onClose, onClick
} from './PromoModal.services';
import Select from '../Select';
import Checkbox from '../Checkbox';
import { isStringNotNull } from '../../utils/tools';
import { getOrderTypes } from '../../utils/shopUtils';
import { UNIT } from '../../constants';
import { getSavedCanals } from '../../utils/orderUtils';
import { DateRange } from 'react-date-range';
import { mainColor } from '../../constants/theme';
import Popover from '@material-ui/core/Popover';
import { parseDate } from '../../utils/suitableDate';
import Button from '../Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import moment from 'moment';
import { SUITABLE_ORDER_TYPES } from '../../constants';
import { checkIntegrationAccess } from 'src/utils/externalIntegration';
const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
};
const MuiMenuItem = withStyles({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#FFFFFF'
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: '#FFFFFF'
    }
  }
})(MenuItem);


function PromoModal({ promo = {}, classes, webapp, mobileApp, isOpen, createPromo, openErrorModal, promotions = {}, closeModal, shopId }) {
  const [stateObj, setStateObjRaw] = useState({
    promo: {
      promoCode: '',
      value: 0,
      isGeneralData: false,
      promotionType: '',
      count: 1,
      minBasketPrice: 0
    },
    isLoading: false,
    errorTitle: false,
    selectedCanals: [],
    selectedOrderTypes: [],
    isExpiredDate: createPromo ? false : promo?.startedDate && promo?.endedDate,
    anchorEl: null,
    open: false,
    selection: {
      startDate: createPromo ? moment().toDate() : promo?.startedDate,
      endDate: createPromo ? moment().toDate() : promo?.endedDate,
      key: 'selection'
    }
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });

  useEffect(() => {
    const { canals = [], orderTypes = [] } = promo;
    setStateObj({
      selectedOrderTypes: getOrderTypes(orderTypes),
      selectedCanals: getCanals(canals),
      promo: _.assign({}, stateObj.promo, promo)
    });
  }, []);

  const renderOrderTypes = () => {
    return (
      <>
        <label className={classes.labelStyle}>Modes de vente</label>
        <div className={`${classes.checkboxStyle} `}>
          {_.map(SUITABLE_ORDER_TYPES, orderType => (
            <Checkbox
              value={stateObj.selectedOrderTypes.indexOf(orderType) > -1}
              text={orderType}
              name={orderType}
              onClick={() => handleChangeOrderTypes(stateObj.selectedOrderTypes, setStateObj, orderType)}
            />
          ))}
        </div>
      </>
    );
  };

  const renderCanals = () => {
    const canals = getCanals(getSavedCanals(webapp, mobileApp));
    return (
      <Select
        as='select'
        custom
        className='w-100'
        label='Canaux de vente'
        multiple
        displayEmpty
        value={canals.filter(value => stateObj.selectedCanals.includes(value))}
        onChange={event => handleChangeCanal(event, setStateObj)}
        renderValue={selected => {
          if (selected.length === 0) {
            return <span> À choisir</span>;
          }

          return selected.join(', ');
        }}
        MenuProps={MenuProps}
      >
        <MuiMenuItem disabled value='' className={classes.textStyle}>
          <span style={{ marginLeft: `${UNIT * 2.0625}px` }}> À choisir</span>
        </MuiMenuItem>
        {canals.map(canal => (
          <MuiMenuItem key={canal} value={canal} className={classes.textStyle}>
            <Checkbox value={stateObj.selectedCanals.indexOf(canal) > -1} text={canal} name={canal} />
          </MuiMenuItem>
        ))}
      </Select>
    );
  };
  const renderRangeDate = () => {
    return (
      <>
        <div className='row d-flex m-0 w-100'>
          <div className='col-6 d-flex pl-0'>
            <Checkbox
              value={stateObj.isExpiredDate}
              onClick={() => handleChange(stateObj.isExpiredDate, setStateObj, createPromo)}
              text='Définir les dates d’utilisations'
              name='isExpiredDate'
              disabled={!createPromo}
            />
          </div>
          {stateObj.isExpiredDate &&
            <div className='d-flex pl-0 mt-1'>
              <Button
                color='secondary'
                outlined
                className={`btn-xs-block ${classes.buttonStyle}`}
                onClick={event => {
                  onClick(event, setStateObj, stateObj);
                }}
                disabled={!createPromo}
              >
                <div className='row ml-0 mr-0 justify-content-center'>
                  {parseDate(stateObj.selection.startDate, stateObj.selection.endDate)}
                  <ArrowDropDownIcon className={classes.arrowIcon} />
                </div>
              </Button></div>
          }
        </div>
        {createPromo &&
          <Popover
            open={stateObj.open}
            anchorEl={stateObj.anchorEl}
            onClose={() => {
              onClose(setStateObj);
            }}
          >
            <DateRange
              minDate={moment().toDate()}
              editableDateInputs={true}
              onChange={ranges => {
                onSelectDate(ranges, setStateObj);
              }}
              rangeColors={[mainColor.secondaryColor]}
              color={mainColor.secondaryColor}
              moveRangeOnFirstSelection={false}
              ranges={[stateObj.selection]}
            />
          </Popover>
        }
      </>)
  };

  const { promoCode, ref, value, isGeneralData, promotionType, count, minBasketPrice } = stateObj.promo;
  const hasRef = checkIntegrationAccess('promoCode', 'optionalRef', shopId) || checkIntegrationAccess('promoCode', 'obligatoryRef', shopId)
  return (
    <Modal
      size='lg'
      showCancelBtn
      header
      loading={stateObj.isLoading}
      isOpen={isOpen}
      title={
        createPromo
          ? 'Ajouter un nouveau code promotionnel'
          : `Modifier le code promotionnel ${promoCode}`
      }
      onClick={() => handleAddPromo(openErrorModal, createPromo, promotions, closeModal, stateObj, setStateObj)}
      btnTxt='Enregistrer'
      handleClose={() => handleClose(closeModal)}
    >
      <Input
        autoFocus
        margin='dense'
        id='promoCode'
        label='Nom du code promotionnel'
        type='text'
        value={promoCode}
        disabled={!createPromo}
        onChange={e => onChangeData(e, stateObj, setStateObj)}
        fullWidth
      />
      {stateObj.errorTitle ? (
        <text className={classes.errorText}>
          Ce code promotionnel existe déjà, veulliez modifier le nom !
        </text>
      ) : null}
      {hasRef && (
        <div className='mb-1'>
          <Input
            margin='dense'
            fullWidth
            id='ref'
            label='Référence du code promo'
            value={ref}
            onChange={e => onChangeData(e, stateObj, setStateObj)}
          />
        </div>
      )}
      <div className='row d-flex m-0 w-100'>
        <div className={`mt-1 ${isStringNotNull(promotionType) && promotionType !== PROMOTYPES.freeDelivery ? 'col-6' : 'col-12'}  d-flex pl-0`}>
          <Select
            as='select'
            custom
            className='w-100'
            label='Type de promotion'
            id='promotionType'
            onChange={e => onChangeData(e, stateObj, setStateObj)}
            value={promotionType}
            defaultValue=''
            required
            name='promotionType'
          >
            <option value='' disabled>
              À choisir
            </option>
            {_.map(PROMOTYPES, type => {
              return <option value={type}>{type}</option>;
            })}
          </Select>
        </div>
        {isStringNotNull(promotionType) && promotionType !== PROMOTYPES.freeDelivery && (
          <div className='col-6 d-flex pl-0'>
            <Input
              margin='dense'
              id='value'
              label='Valeur de la réduction'
              type='number'
              value={value < 0 ? 0 : value}
              onChange={e => onChangeData(e, stateObj, setStateObj)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start' className='pb-2'>
                    {promotionType === PROMOTYPES.percentage ? '%' : '€'}
                  </InputAdornment>
                )
              }}
            />
          </div>
        )}
      </div>
      <div className='row d-flex m-0 w-100'>
        <div className='col-6 d-flex pl-0'>
          <Input
            margin='dense'
            id='count'
            label="Nombre d'utilisation par client"
            type='number'
            value={count < 0 ? 0 : count}
            fullWidth
            onChange={e => onChangeData(e, stateObj, setStateObj)}
          />
        </div>
        <div className='col-6 d-flex pl-0'>
          <Input
            margin='dense'
            id='minBasketPrice'
            label="Valeur minimale du panier"
            type='number'
            value={minBasketPrice < 0 ? 0 : minBasketPrice}
            fullWidth
            onChange={e => onChangeData(e, stateObj, setStateObj)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start' className='pb-2'>€</InputAdornment>
              )
            }}
          />
        </div>
      </div>

      <div className='mb-2 mt-2'>{renderCanals()}</div>
      <div className='mb-2 mt-2'>{renderOrderTypes()}</div>
      <div className='mb-2 mt-2'>{renderRangeDate()}</div>

      {checkAccess('features', 'globalCodePromo') ? (
        <Checkbox
          value={isGeneralData}
          onClick={() => handleCheckBox(!isGeneralData, stateObj, setStateObj)}
          text='Appliquer ce code sur tous les magasins'
          name='isGeneralData'
        />
      ) : null}

    </Modal>
  );
}

function mapStateToProps({ firebaseRealTime, user }) {
  const { nbShops, shopId } = user;
  const { shop = {}, generalConfig } = firebaseRealTime;
  const { promotions } = shop;
  const { orderTypes, webapp = {}, mobileApp = {} } = generalConfig;
  return {
    promotions,
    nbShops,
    shopId,
    orderTypes,
    webapp,
    mobileApp
  };
}
export default connect(mapStateToProps, actions)(withStyles(styles)(PromoModal));
